<header>
  <app-icon-button [icon]="closeIcon" (click)="close()"></app-icon-button>
  <div>
    <label for="total-price">{{ priceHeader }}</label>
    @let loading = isLoading$ | async;
    @if (!loading) {
      <span id="total-price">{{ price$ | async | number: '.2-2' : locale }} {{ currency | displayCurrency }}</span>
    }
    @if (loading) {
      <div class="loading">
        <img src="assets/preloader.gif" alt="loading price" />
      </div>
    }
    <app-text-button [routerLink]="basketOverviewUrl" (click)="close()" [disabled]="(productLines$ | async).length < 1">
      {{ basketButtonText }}
    </app-text-button>
  </div>
</header>
<div>
  @for (productLine of productLines$ | async; track productLine.productId) {
    @if (getProduct(productLine) | async; as product) {
      <div>
        <div class="product-line">
          <div class="product">
            <a [routerLink]="createProductUrl(product)" (click)="close()">
              <div class="basket-product-image-container">
                @defer (on viewport({ rootMargin: "50px", threshold: 0.3 })) {
                  <img
                    [ngSrc]="(product | primary) || 'assets/placeholder.png'"
                    [alt]="product.productDisplayName"
                    loading="lazy"
                    [width]="88"
                    [height]="66"
                    [loaderParams]="{ autorotate: true, quality: 80 }"
                  />
                } @placeholder {
                  <img src="assets/placeholder.png" [alt]="product.productDisplayName" [width]="88" [height]="66" />
                }
              </div>
              <div class="basket-product-content">
                <b>{{ product.productDisplayName }}</b>
                @if (!simpleOverviewItems) {
                  <span>{{ product.summary }}</span>
                }
                @if (simpleOverviewItems && product | modules; as moduleChoices) {
                  @for (module of moduleChoices; track module.id) {
                    <span class="simple"> {{ module.moduleParentName }}: {{ module.productDisplayName }} </span>
                  }
                }
                <app-price [forceSuperscript]="true" [value]="productLine | sum"></app-price>
              </div>
            </a>
            @if (!productLine.giftCardInfo) {
              <app-counter
                [count]="productLine.quantity"
                [minCount]="product.minCount"
                [lockRemove]="productLine.quantity === product.minCount"
                [packageOptions]="product.packageOptions"
                (add)="addProduct(product, $event.quantity, $event.packageOptions)"
                (remove)="removeProduct(product, $event.quantity, $event.packageOptions)"
              ></app-counter>
            }
            @if (productLine.giftCardInfo) {
              <span class="basket-product-quantity">{{ productLine.quantity }}</span>
            }
            <app-icon-button class="remove-product" [icon]="closeIcon" [border]="false" (click)="deleteProduct(product)"></app-icon-button>
          </div>
          @if (!simpleOverviewItems && product | modules; as moduleChoices) {
            <div class="product-modules">
              @for (module of moduleChoices; track module.id) {
                <div class="module-line">
                  <div class="basket-product-image-container">
                    @defer (on viewport({ rootMargin: "50px", threshold: 0.3 })) {
                      <img
                        [ngSrc]="(module | primary) || 'assets/placeholder.png'"
                        [alt]="module.productDisplayName"
                        loading="lazy"
                        [width]="88"
                        [height]="66"
                        [loaderParams]="{ autorotate: true, quality: 80 }"
                      />
                    } @placeholder {
                      <img src="assets/placeholder.png" [alt]="module.productDisplayName" [width]="88" [height]="66" />
                    }
                  </div>
                  <div class="basket-product-content">
                    <b>{{ module.productDisplayName }}</b>
                    <span>{{ module.summary }}&#8205;</span>
                  </div>
                  <div class="module-quantity">
                    @if (module.price || module.quantity !== 1) {
                      <div>
                        {{ module.quantity }}
                        @if (productLine.quantity !== 1) {
                          <mat-icon [svgIcon]="multiplyIcon" class="multiply-icon"></mat-icon>
                        }
                        {{ productLine.quantity !== 1 ? productLine.quantity : '' }}
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
  }
</div>
